import { gql, useMutation } from "@apollo/client";
import type { MutationHookOptions } from "@apollo/client";

const TEAM_MEMBER_CREATE_MUTATION = gql`
  mutation TeamMemberCreate(
    $name: String!
    $email: String!
    $phone: String
    $order: String
    $position: String!
    $description: String
    $avatar: Upload!
    $listingAgentKey: String!
  ) {
    createTeamMember(
      name: $name
      email: $email
      phone: $phone
      order: $order
      position: $position
      description: $description
      avatar: $avatar
      listingAgentKey: $listingAgentKey
    ) {
      teamMember {
        id
        name
        email
        phone
        order
        position
        description
        slug
        avatarLarge
        avatarMedium
        avatarThumb
      }
      teamMemberErrors
      listingAgentErrors
    }
  }
`;

interface TeamMemberCreateVariables {
  name: string;
  email: string;
  position: string;
  avatar: File;
  phone?: string | null;
  order?: string | null;
  description?: string | null;
  listingAgentKey: string;
}

interface TeamMemberCreateData {
  createTeamMember: {
    teamMember: {
      id: string;
      name: string;
      phone: string;
      order: number;
      position: string;
      description: string;
      slug: string;
      avatarLarge: string;
      avatarMedium: string;
      avatarThumb: string;
    };
    teamMemberErrors: string[];
    listingAgentErrors: string[];
  };
}

const useTeamMemberCreateMutation = (
  options?: MutationHookOptions<TeamMemberCreateData, TeamMemberCreateVariables>,
) => {
  return useMutation<TeamMemberCreateData, TeamMemberCreateVariables>(
    TEAM_MEMBER_CREATE_MUTATION,
    options,
  );
};

export { useTeamMemberCreateMutation };
export type { TeamMemberCreateData, TeamMemberCreateVariables };
